module.exports = __webpack_public_path__ + "img/bch.d03784fb.png";